import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtTag } from "server/models"
import {
    StoreType,
    setTagEdit,
} from "client/store"
import {
    Link,
    DateFormatter,
    TableColumn,
} from "client/components"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (tag: MtTag) => (
                <Link
                    href="/#"
                    onClick={() => dispatch(setTagEdit(tag))}
                >
                    {tag.name}
                </Link>
            ),
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (tag: MtTag) => <DateFormatter date={tag.createdAt} />,
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        },
    ]

    return columns
}
export default Columns
